export const environment = {
    production: false,
    environmentName: 'development',
    authApiUrl: 'https://dev-identity-api.relaxedcoder.com',
    //authApiUrl: 'https://localhost:44361',
    apiUrl: 'https://dev-fibeacon-api.relaxedcoder.com',
    //apiUrl: 'https://localhost:44362',
    applicationId: '6de5a9ca-caaf-45fa-a3a8-e184276305e3',
    captchaSiteKey: '0x4AAAAAAA76OxW-GS2TcUrI',
    googleLoginKey: '398550446888-4l01h7akvsji5k5ahktg3rmahbhgduas.apps.googleusercontent.com',
    dodoPaymentsMode: 'test' as const,
};
